import React from "react";

const APP_TERMS_PATH = "/terms-of-service";
const APP_PRIVACY_PATH = "/privacy-policy";

/** Terms copy under trending / category upload modals. */
export function ModalUploadLegalNotice({ className = "v1-trending-upload-terms" }) {
  return (
    <p className={className}>
      By uploading an image you hereby agree to our{" "}
      <a href={APP_TERMS_PATH}>Terms of Service</a> and{" "}
      <a href={APP_PRIVACY_PATH}>Privacy Policy</a>.
    </p>
  );
}

/** Terms copy on the main dashboard upload hero. */
export function DashboardUploadLegalNotice({ className }) {
  return (
    <p className={className}>
      By uploading an image or URL you agree to our{" "}
      <a href={APP_TERMS_PATH}>Terms of Use</a> and{" "}
      <a href={APP_PRIVACY_PATH}>Privacy Policy</a>
    </p>
  );
}
